export enum BILoginType {

    Regular = "Regular",
    Remembered = "Remembered",
    Social = "Social",
    Biometric = "Biometric",
}
